import React from 'react'
import { useSession } from '../../ApiCalls/useSession';
import { FaCircleCheck } from "react-icons/fa6";
import { Link } from 'react-router-dom';

function SellerRegistrationSucessfull() {
useSession()

  return (
    <>
      <div className="grid h-screen w-screen grid-cols-1 md:grid-cols-2">
        {/* Left side */}
        <div className="relative border-gray-300 flex flex-col items-center md:items-start justify-between border-r-2 p-4 bg-cover bg-center h-[25vh] md:h-full" style={{ backgroundImage: "url('/images/profile/BImage.png')" }}>
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black opacity-60"></div>

          {/* Logo container */}
          <div className="mb-4 flex items-start z-10">
            <img src="/images/logo/footer_logo.png" alt="Icon" className="w-3/4 md:w-auto" />
          </div>
        </div>

        {/* Right side */}
        <div className="flex flex-col items-center justify-center  md:h-full">
          <div className="flex w-full sm:w-[450px] flex-col  items-center px-5 md:p-10 rounded-xl gap-4">
            <FaCircleCheck className=" text-[#05BF02] text-[200px]" />
            <p className='text-center text-lg text-[#606060] font-bold mb-5 mt-2'>
              Great! <br />
              Your registration is Sucessful.
            </p>
            <Link to="/seller" className='w-full text-center rounded-xl px-6 font-bold py-3 text-black transition duration-200 bg-[#FFAE00]'>
              Explore Bricksnmix
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default SellerRegistrationSucessfull